import { useSelector } from "react-redux";
import User2 from "../../assets/african-women.jpg";
import User3 from "../../assets/black-man-chef.jpg";
import User1 from "../../assets/user1.webp";
import { t } from "../../translations";
import "../styles/careers.css";

const OurGoals_UserComments = () => {
  const lang = useSelector((state) => state.lang);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "3rem",
        textAlign: "start",
        flexWrap: "wrap"
      }}
    >
      <div className="GoalContainer">
        <div className="GoalTextContainer">
          <div
            style={{
              position: "relative",
              paddingBottom: "7px",
              marginBottom: "25px",
              width: "fit-content"
            }}
          >
            <h1
              class="h1-sectionTitleLower"
              style={{ lineHeight: "1.5rem", paddingBottom: "1rem" }}
            >
              {t("our_goals_user_comments.building_diverse_team", lang)}
            </h1>
          </div>
          <p
            style={{
              fontSize: "1.1rem",
              marginBottom: "2rem",
              lineHeight: "1.8rem"
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                display: "block",
                marginBottom: "1.5rem"
              }}
            >
              {t("our_goals_user_comments.employees_represent", lang)}
            </span>
            {t("our_goals_user_comments.diversity_description", lang)}
          </p>
        </div>
        <div className="textContainerLocalisation">
          <div
            style={{
              position: "relative",
              paddingBottom: "7px",
              marginBottom: "25px",
              width: "fit-content"
            }}
          >
            <h1 class="h1-sectionTitleLower">
              {t("our_goals_user_comments.localization", lang)}
            </h1>
          </div>
          <p
            style={{
              fontSize: "1.1rem",
              marginBottom: "2rem",
              lineHeight: "1.8rem"
            }}
          >
            {t("our_goals_user_comments.remote_team_description", lang)}
          </p>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "5rem",
          backgroundColor: "#f4eaea"
        }}
      >
        <div className="commentCardContainer">
          <div className="CommentCard">
            <p
              style={{
                fontSize: "1.2rem",
                lineHeight: "1.8rem",
                fontWeight: "600",
                color: "#5C5C5C"
              }}
            >
              <span style={{ color: "black" }}>“</span>
              {t("our_goals_user_comments.testimonial_1", lang)}
              <span style={{ color: "black" }}>”</span>
            </p>
            <div style={{ display: "flex", width: "100%" }}>
              <div className="ProfilPicComment">
                <img
                  src={User1}
                  style={{ width: "100%", objectFit: "cover" }}
                  alt="User profil image"
                />
              </div>
              <div className="CommentCardProfil">
                <span className="CommentCardProfilName">
                  {t("our_goals_user_comments.user_1_name", lang)}
                </span>
                <span className="CommentCardProfilJob">
                  {t("our_goals_user_comments.user_1_job", lang)}
                </span>
              </div>
            </div>
          </div>
          <div className="CommentCard">
            <p
              style={{
                fontSize: "1.2rem",
                lineHeight: "1.8rem",
                fontWeight: "600",
                color: "#5C5C5C"
              }}
            >
              <span style={{ color: "black" }}>“</span>
              {t("our_goals_user_comments.testimonial_2", lang)}
              <span style={{ color: "black" }}>”</span>
            </p>
            <div style={{ display: "flex", width: "100%" }}>
              <div className="ProfilPicComment">
                <img
                  src={User2}
                  style={{ width: "100%", objectFit: "cover" }}
                  alt="User profil image"
                />
              </div>
              <div className="CommentCardProfil">
                <span className="CommentCardProfilName">
                  {t("our_goals_user_comments.user_2_name", lang)}
                </span>
                <span className="CommentCardProfilJob">
                  {t("our_goals_user_comments.user_2_job", lang)}
                </span>
              </div>
            </div>
          </div>
          <div className="CommentCard">
            <p
              style={{
                fontSize: "1.2rem",
                lineHeight: "1.8rem",
                fontWeight: "600",
                color: "#5C5C5C"
              }}
            >
              <span style={{ color: "black" }}>“</span>
              {t("our_goals_user_comments.testimonial_3", lang)}
              <span style={{ color: "black" }}>”</span>
            </p>
            <div style={{ display: "flex", width: "100%" }}>
              <div className="ProfilPicComment">
                <img
                  src={User3}
                  style={{ width: "100%", objectFit: "cover" }}
                  alt="User profil image"
                />
              </div>
              <div className="CommentCardProfil">
                <span className="CommentCardProfilName">
                  {t("our_goals_user_comments.user_3_name", lang)}
                </span>
                <span className="CommentCardProfilJob">
                  {t("our_goals_user_comments.user_3_job", lang)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurGoals_UserComments;
